module.exports = __webpack_public_path__ + "assets/img/arrowUpIcon.edd8b82e.svg";